import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import Heading from 'LuxKit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import BodyText from 'LuxKit/Typography/BodyText'

const PriceSection = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.six};
  display: flex;
  flex-direction: column;
  padding: ${rem(20)};
  border-radius: ${props => props.theme.borderRadius.M};

  ${mediaQueryUp.tablet} {
    flex-direction: row;
  }
`

const DateWrapper = styled.div`
  flex: 1;
  text-align: center;

  & + & {
    border-top: 1px solid ${props => props.theme.palette.neutral.default.five};
    padding-top: ${rem(12)};
    margin-top: ${rem(12)};

    ${mediaQueryUp.tablet} {
      padding-top: 0;
      margin-top: 0;
      border-top: 0;
      padding-left: ${rem(12)};
      margin-left: ${rem(12)};
      border-left: 1px solid ${props => props.theme.palette.neutral.default.five};
    }
  }
`

interface Props {
  tripDates: string
  itemDates: string
  itemType: string
  className?: string
}

function DateChangeView(props: Props) {
  const {
    tripDates,
    itemDates,
    itemType,
    className,
  } = props

  return (
    <PriceSection className={className}>
      <DateWrapper>
        <BodyText variant="medium" colour="neutral-one">
          Your overall trip dates
        </BodyText>
        <Heading variant="heading5" colour="neutral-one">
          {tripDates}
        </Heading>
      </DateWrapper>
      <DateWrapper>
        <BodyText variant="medium" colour="neutral-one">
          {itemType} dates
        </BodyText>
        <Heading variant="heading5" colour="neutral-one">
          {itemDates}
        </Heading>
      </DateWrapper>
    </PriceSection>
  )
}

export default DateChangeView
